import React from "react";
import { Col } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import history from "../../routes/history";
import './EmpStaff.css';

const CompanyStaff = () => {
  return (
    <div className="company-mainbg">
      <Col xs={24} sm={24} md={24} lg={24}>
        <div style={{ padding: "10px" }}> </div>
        <ArrowLeftOutlined
           className="emp-back"
          onClick={() => history.push("/companyprofile")}
        />
      </Col>
      <div className="company-topcont" style={{display:'flex',justifyContent:'center'}}>
        <div className="company-subcont" style={{ width: '800px', height: '435px',marginBottom:'20px' }}>
          <div className="company-heading">Company staff album</div>
          <div className="company-txt">
          Showcase your amazing team members!
            <br />
            <p style={{ marginTop: "1rem", marginBottom: "20px" }}>
              Tell their story by adding their bio using the edit bio feature.
            </p>
          </div>
          <div className="staff-btn">
          <div className="add-company-btn">
            <button className="company-btn" onClick={() => history.replace("/uploademployeepic")}>
              + Add an employee
            </button>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyStaff;
